export default class IBean {
    constructor() {}
}
